export default __webpack_public_path__ + "static/media/fMaltoBuza37.e9ba337e.png";